import { useSearchParams, type NavigateOptions } from "react-router"

export const useQueryParams = (
  options: NavigateOptions = { replace: true, preventScrollReset: true }
): UseQueryParams => {
  const [searchParams, setSearchParams] = useSearchParams()

  const add = (key: string, value: string) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev)
      params.set(key, value)
      return params
    }, options)
  }

  const remove = (key: string) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev)
      params.delete(key)
      return params
    }, options)
  }

  return {
    searchParams,
    add,
    remove
  }
}

export interface UseQueryParams {
  searchParams: URLSearchParams
  add: (key: string, value: string) => void
  remove: (key: string) => void
}
